import React from 'react';
import './styles.scss';
import {LocaleType} from "../../../interfaces/Locale";

export default function Foot({locale}:{locale:LocaleType}){
    return <div className="foot">
        {locale["Layout.Foot.copyright"]}
    </div>
}